import { components, PlaceholderProps } from 'react-select';

export const DropdownPlaceholder = ({ children, ...props }: PlaceholderProps) => {
  return (
    <components.Placeholder {...props} className="stihl-text-body-default-reg">
      {children}
    </components.Placeholder>
  );
};
